export default "__VITE_ASSET__b3326c24__"